import { ObjectWithId } from '@sdk/common/types/ObjectWithId';
import { UserFromApi } from '@sdk/users/types/UserFromApi';

// deleted users are returned in the response as full objects instead of just ids
// (i.e. message.author, article.user)
export const isDeletedUserFromApi = (user: ObjectWithId | UserFromApi): user is UserFromApi => {
  const u = user as UserFromApi;
  return u.type === 'user' && u.deleted;
};
